import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-question-menu',
  templateUrl: './question-menu.component.html',
  styleUrls: ['./question-menu.component.scss']
})
export class QuestionMenuComponent implements OnInit {

  public expandMenu = this.dataSvc.expandMenu;
  
  public changeQuestionTimer: any;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) {
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
   }

  ngOnInit() {
  }

  goToQuestion(i) {
    clearTimeout(this.changeQuestionTimer);
    this.changeQuestionTimer = setTimeout(() => { 
      this.dataSvc.setQuestion(i);
    }, 100);
  }
  

}
